export default {
  account: null,

  accountId: null,

  forms:[],
  formsPage: 0,
  formsLoading: false,
  isFormsFullList: false,
  totalForms: 0,
  searchText: '',
  formsSorting: 'title',

  filledForms:[],
  filledTotalForms: 0,
  filledFormsPage: 1,
  filledFormsPageSize: 25,
  filledFormsFilters: {},

  loading: false,
  notification: null,

  accountSettings: { smtp: {} },

  unreadedSubmissions: [],
  unreadedPage: 0,
  unreadedLoading: false,
  isUnreadedFullList: false,
  unreadedPageSize: 25,
  unreadedTotal: 0
}



// WEBPACK FOOTER //
// ./client/store/state.js